import { IProduct } from "tsi-common-react/src/models/catalogue";

export const isMattress = (product: IProduct) => {
    return product.product_class_slug === "mattress";
};
